














import { Component, Vue, Watch } from "vue-property-decorator";
import ImageList from "./components/ImageList.vue";
import Profile from "./components/Profile.vue";
import Navbar from "./components/Navbar.vue";

@Component({
  components: {
    Profile,
    ImageList,
    Navbar,
  },
})
export default class App extends Vue {
  transitionName = "forward";
  screen = "home";

  @Watch("$route")
  route(to: any, from: any) {
    if (to.params["stack-key-dir"] === "forward") {
      this.transitionName = "forward";
    } else {
      this.transitionName = "back";
    }
  }
}
